import React from "react";
import { Box, Typography } from "@mui/material";

export const TEMPLATE_WIDTH = 3508;
export const TEMPLATE_HEIGHT = 2480;

export const config = {
  width: TEMPLATE_WIDTH,
  height: TEMPLATE_HEIGHT,

  regions: [
    {
      id: "front",
      x: 0.05,
      y: 0.12,
      width: 0.3,
      height: 0.55,
    },

    {
      id: "back",
      x: 0.38,
      y: 0.12,
      width: 0.3,
      height: 0.55,
    },

    {
      id: "detail1",
      x: 0.05,
      y: 0.72,
      width: 0.3,
      height: 0.2,
    },

    {
      id: "detail2",
      x: 0.38,
      y: 0.72,
      width: 0.3,
      height: 0.2,
    },
  ],

  textFields: [
    {
      id: "marca",
      x: 0.05,
      y: 0.02,
      width: 0.35,
      height: 0.07,
      fontSize: 60,
      fontWeight: "bold",
      color: "#ffffff",
      backgroundColor: "grey.900",
    },

    {
      id: "info",
      x: 0.72,
      y: 0.12,
      width: 0.23,
      height: 0.8,
      fontSize: 40,
      fontWeight: "normal",
      color: "#000000",
    },
  ],
};

function CollectionBoardPreview({ marca = "MARCA", className }) {
  return (
    <Box
      className={className}
      sx={{
        width: "100%",
        height: "100%",
        aspectRatio: `${TEMPLATE_WIDTH}/${TEMPLATE_HEIGHT}`,
        bgcolor: "#fff",
        border: "1px solid",
        borderColor: "divider",
        position: "relative",
      }}
    >
      {/* MARCA */}
      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "2%",
          width: "35%",
          height: "7%",
          bgcolor: "grey.900",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 1.5,
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontWeight: "bold",
            fontSize: ".3rem",
          }}
        >
          {marca}
        </Typography>
      </Box>

      {/* FRONT */}
      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "12%",
          width: "30%",
          height: "55%",
          border: "1px dashed",
          bgcolor: "#eee",
        }}
      />

      {/* BACK */}
      <Box
        sx={{
          position: "absolute",
          left: "38%",
          top: "12%",
          width: "30%",
          height: "55%",
          border: "1px dashed",
          bgcolor: "#eee",
        }}
      />

      {/* DETAIL1 */}
      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "72%",
          width: "30%",
          height: "20%",
          border: "1px dashed",
          bgcolor: "#eee",
        }}
      />

      {/* DETAIL2 */}
      <Box
        sx={{
          position: "absolute",
          left: "38%",
          top: "72%",
          width: "30%",
          height: "20%",
          border: "1px dashed",
          bgcolor: "#eee",
        }}
      />

      {/* INFO */}
      <Box
        sx={{
          position: "absolute",
          left: "72%",
          top: "12%",
          width: "23%",
          height: "80%",
          border: "1px dashed",
          bgcolor: "#fafafa",
        }}
      />
    </Box>
  );
}

export default CollectionBoardPreview;
